// Account settings: name and company, the weekly digest, sign out.
import { useState } from "react";
import { doc, serverTimestamp, updateDoc } from "@estra/client/firestore";
import { useConsole } from "../App.tsx";
import { auth, db } from "../api.ts";
import { Card, PageHead, useAction } from "../ui.tsx";
import { DigestToggle } from "./project/Story.tsx";

export function AccountPage() {
  const { user, account } = useConsole();
  const [name, setName] = useState(String(account.name ?? ""));
  const [company, setCompany] = useState(String(account.company ?? ""));
  const act = useAction();
  return (
    <div className="page medium">
      <PageHead kicker="Account" title="Your account" />
      <div className="cards">
        <Card title="Profile" sub={user.email ?? ""}>
          <label>Your name<input value={name} onChange={(e) => setName(e.target.value)} /></label>
          <label>Company<input value={company} onChange={(e) => setCompany(e.target.value)} /></label>
          <div className="row"><button className="btn btn-small" disabled={act.busy} onClick={() => act.run(() => updateDoc(doc(db, `accounts/${user.uid}`), { name: name.trim(), company: company.trim(), updatedAt: serverTimestamp() }), "Saved.")}>Save</button>{act.note}</div>
        </Card>
        <Card title="Weekly digest" sub="Every Monday: each project's numbers with deltas, the top story lines and new milestones."><DigestToggle /></Card>
        <Card title="Sign out"><div><button className="btn btn-ghost btn-small" onClick={() => void auth.signOut()}>Sign out of this browser</button></div></Card>
      </div>
    </div>
  );
}
